import { useState, useEffect } from 'react';
import { hasParam } from '~/utils/query-params';
import useSiteWideBannerQuery from '../graphql/queries/use-site-wide-banner-query';

const useSiteWideBanner = () => {
  const [showRefNotification, setShowRefNotification] = useState(false);
  const [showAffiliateNotification, setShowAffiliateNotification] = useState(false);

  useEffect(() => {
    setShowRefNotification(hasParam('ref'));
    setShowAffiliateNotification(hasParam('insider'));
  }, []);

  const { defaultSiteWideBanner, affiliateNotification, referralNotification, mobileSiteWideBanner } =
    useSiteWideBannerQuery();

  if (showRefNotification) {
    return { siteWideBanner: referralNotification };
  }
  if (showAffiliateNotification) {
    return { siteWideBanner: affiliateNotification };
  }

  return { siteWideBanner: defaultSiteWideBanner, mobileSiteWideBanner };
};

export default useSiteWideBanner;
